// frontend/shared-ui/src/forms/schemas/hardware.js
export default {
    slug: 'hardware',
    label: 'Hardware (Clamps, Brackets, Suspension)',
    defaultUnit: 'pcs',
    costDefaults: {
        avgVolumeCbm: 0.0005,
        suggestedMarkupPct: 50,
        freightSensitivity: 'low',
        note: 'Small metal parts — cheap CBM, high markup',
    },
    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 2,
            fields: [
                { key: 'hardwareType', label: 'Hardware Type', type: 'select', required: true, options: ['Wedge Clamp', 'Suspension Clamp', 'Bracket', 'Anchoring Clamp'] },
                { key: 'sizeRange', label: 'Size Range (e.g. 6-9mm)', type: 'text' },
                { key: 'material', label: 'Material', type: 'select', options: ['Plastic', 'Metal', 'Aluminum', 'Stainless Steel'] },
                { key: 'loadRating', label: 'Load Rating', type: 'number', unit: 'kN' },
            ],
        },
    ],
    buildSku(v) {
        const parts = ['HW', v.hardwareType ? v.hardwareType.substring(0, 3).toUpperCase() : '', v.sizeRange ? v.sizeRange.replace(/\s+/g, '') : '', v.material ? v.material.substring(0, 3).toUpperCase() : ''];
        return parts.filter(Boolean).join('-').toUpperCase();
    },
    buildName(v) {
        const bits = [];
        if (v.sizeRange) bits.push(v.sizeRange);
        if (v.material) bits.push(v.material);
        if (v.hardwareType) bits.push(v.hardwareType);
        if (v.loadRating) bits.push(`(${v.loadRating}kN)`);
        return bits.join(' ');
    },
    attributeSchema: [
        { key: 'hardwareType', label: 'Hardware Type' },
        { key: 'sizeRange', label: 'Size Range' },
        { key: 'material', label: 'Material' },
        { key: 'loadRating', label: 'Load Rating' },
    ],
};